export const ExtendedFieldType = {
  AR: 'AR',
  CASE: 'Case'
}